import { render, staticRenderFns } from "./Select-Asset.vue?vue&type=template&id=6e87d80e"
import script from "./Select-Asset.vue?vue&type=script&lang=js"
export * from "./Select-Asset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports